import { CalendarDots, CreditCard, FileText, Target, Timer } from "@phosphor-icons/react";

interface Props {
  /** Profil prenesen sa stare platforme: podaci su već tu i treba ih provjeriti. */
  migrated?: boolean;
  showAgreement?: boolean;
}

export function WelcomeStep({ migrated = false, showAgreement = false }: Props) {
  const cards = [
    ...(showAgreement
      ? [{ icon: <FileText className="size-5" weight="duotone" />, title: "Ugovor", sub: migrated ? "Podaci za isplatu i prihvatanje ugovora" : "Pročitaj i prihvati ugovor o saradnji" }]
      : []),
    ...(migrated
      ? [{ icon: <CalendarDots className="size-5" weight="duotone" />, title: "Provjera profila", sub: "Pogledaj preneseno radno vrijeme i uslugu" }]
      : [
          { icon: <CalendarDots className="size-5" weight="duotone" />, title: "Radno vrijeme", sub: "Kada primaš klijente" },
          { icon: <CreditCard className="size-5" weight="duotone" />, title: "Usluga i cijena", sub: "Šta nudiš i po kojoj cijeni" },
        ]),
    { icon: <Target className="size-5" weight="duotone" />, title: "Oblasti rada", sub: "Da te pravi klijenti nađu" },
  ];
  return (
    <div className="space-y-6">
      <ol className="grid gap-3 sm:grid-cols-2">
        {cards.map((c, i) => (
          <li key={c.title} className="flex items-start gap-3 rounded-xl border border-border bg-card p-4 shadow-sm">
            <span className="text-primary">{c.icon}</span>
            <div>
              <h4 className="text-sm font-semibold">{i + 1}. {c.title}</h4>
              <p className="text-xs text-muted-foreground">{c.sub}</p>
            </div>
          </li>
        ))}
      </ol>
      <div className="flex gap-3 rounded-xl border border-border bg-muted/20 p-4 text-sm text-muted-foreground">
        <Timer className="size-5 shrink-0 text-primary" weight="duotone" />
        {migrated ? (
          <p>
            <b className="text-foreground">Treba desetak minuta</b>, najviše za čitanje ugovora. Tvoj profil,
            radno vrijeme i usluga su već preneseni sa stare platforme, samo provjeri da je sve tačno.
            Sve možeš mijenjati i kasnije u Postavkama.
          </p>
        ) : (
          <p>
            <b className="text-foreground">Treba desetak minuta.</b> Osnovni podaci s prijave su već tu, sada
            podešavamo samo ono što čini profil aktivnim. Sve se sprema usput i možeš promijeniti kad god.
          </p>
        )}
      </div>
    </div>
  );
}
